const topSlide = (() => {

  let sW = window.innerWidth;
  let setSlidesPerView;
  // let speed;
  if (sW > 750) {
    setSlidesPerView = 3.2
  } else {
    setSlidesPerView = 3
  }

  // console.log("object");
  const swiper = new Swiper(".js-slider-1", {
    slidesPerView: setSlidesPerView,
    loop: true,
    loopedSlides: 7,
    loopAdditionalSlides: 1,
    speed: 14000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });

  const swiper2 = new Swiper(".js-slider-2", {
    slidesPerView: setSlidesPerView,
    loop: true,
    loopedSlides: 7,
    loopAdditionalSlides: 1,
    speed: 14000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      reverseDirection: true, // 逆方向有効化
    },
  });
})();
export default topSlide;